/* nm-home.js · portada (siempre activo, incluso sin animaciones): carrusel, marquesina y pestañas. */
document.addEventListener('DOMContentLoaded',function(){
'use strict';
const NM=window.NM=window.NM||{};
const $=s=>document.querySelector(s),$$=s=>[...document.querySelectorAll(s)];
const root=document.documentElement,reduce=root.classList.contains('rm');

/* ---------- hero: frascos reales bajo la cápsula ----------
   1) recorte: se mide el contenido real (alfa) de cada foto en un canvas de ≤96 px y la foto se escala/coloca para que el frasco
      llene su lugar y pise el podio (las fotos de la tienda traen márgenes transparentes distintos). Si el canvas no se puede leer, queda «contain».
   2) entrada: cuando la cápsula de partículas ya se formó (≈1 s después de __glReady) o, sin partículas/móvil, al cargar: html.hpb-in. */
const hst=$('.hstage');
if(hst){
  const figs=[...hst.querySelectorAll('.hpb-fig img')];
  const fit=im=>{try{const nw=im.naturalWidth,nh=im.naturalHeight,box=im.parentElement,W=box.clientWidth,H=box.clientHeight;if(!nw||!nh||!W||!H)return;
    let b=im._bb;if(!b){const k=Math.min(1,96/Math.max(nw,nh)),w=Math.max(1,Math.round(nw*k)),h=Math.max(1,Math.round(nh*k)),c=document.createElement('canvas');c.width=w;c.height=h;
      const x=c.getContext('2d',{willReadFrequently:true});x.drawImage(im,0,0,w,h);const d=x.getImageData(0,0,w,h).data;let x0=w,y0=h,x1=-1,y1=-1;
      for(let yy=0;yy<h;yy++)for(let xx=0;xx<w;xx++)if(d[(yy*w+xx)*4+3]>28){if(xx<x0)x0=xx;if(xx>x1)x1=xx;if(yy<y0)y0=yy;if(yy>y1)y1=yy}
      if(x1<0)return;const op=d[3]>200&&d[(w-1)*4+3]>200;b=im._bb={x0:x0/w,y0:y0/h,x1:(x1+1)/w,y1:(y1+1)/h,op};im.closest('.hpb').classList.toggle('is-opaque',op)}
    const cw=(b.x1-b.x0)*nw,ch=(b.y1-b.y0)*nh,sc=Math.min(W/cw,H/ch),iw=nw*sc,ih=nh*sc,l=(W-cw*sc)/2-b.x0*iw,t=H-b.y1*ih;
    Object.assign(im.style,{inset:'auto',left:(l/W*100).toFixed(3)+'%',top:(t/H*100).toFixed(3)+'%',width:(iw/W*100).toFixed(3)+'%',height:(ih/H*100).toFixed(3)+'%',maxWidth:'none',objectFit:'fill'});
    im.closest('.hpb').classList.add('is-fit')}catch(e){}};
  const ready=figs.map(im=>new Promise(r=>{const go=()=>{fit(im);r()};if(im.complete&&im.naturalWidth)go();else{im.addEventListener('load',go,{once:true});im.addEventListener('error',r,{once:true})}}));
  if(window.ResizeObserver){let rq=0;new ResizeObserver(()=>{cancelAnimationFrame(rq);rq=requestAnimationFrame(()=>figs.forEach(fit))}).observe(hst)}
  const show=()=>{if(root.classList.contains('hpb-in'))return;root.classList.remove('hpb-wait');root.classList.add('hpb-in')};
  if(reduce||!root.classList.contains('hpb-wait'))show();
  else{
    const t0=performance.now(),mob=matchMedia('(max-width:820px)').matches;
    const wantGL=!mob&&!!$('#gl')&&!document.querySelector('script[data-particles="false"]');
    const imgs=Promise.race([Promise.all(ready),new Promise(r=>setTimeout(r,2600))]);
    imgs.then(()=>{(function wait(){const el=performance.now()-t0;
      if(!wantGL||root.classList.contains('nogl')){setTimeout(show,Math.max(0,(mob?350:650)-el));return}
      if(window.__glReady){setTimeout(show,950);return}
      if(el>3200){show();return}setTimeout(wait,80)})()});
  }
  NM.heroBottles={fit:()=>figs.forEach(fit),show};
}
/* ---------- destacados: nunca repetir el producto en primer plano (red de seguridad del ajuste skip_product) ---------- */
const spH=($('#spot')||{dataset:{}}).dataset.handle;
if(spH)$$('#track .card[data-handle]').forEach(c=>{if(c.dataset.handle===spH){c.remove();const d=$('#dots i:last-child');if(d)d.remove()}});
/* ---------- carrusel móvil: puntos ---------- */
const track=$('#track'),dots=$$('#dots i');
if(track&&dots.length){dots[0].classList.add('on');
track.addEventListener('scroll',function(){const cards=track.querySelectorAll('.card');const pad=parseFloat(getComputedStyle(track).scrollPaddingLeft)||0;let i=0,best=1e9;cards.forEach(function(c,k){const d=Math.abs(c.offsetLeft-track.scrollLeft-pad);if(d<best){best=d;i=k}});dots.forEach(function(d,k){d.classList.toggle('on',k===i)})},{passive:true})}
/* ---------- marquesina: pausa (WCAG 2.2.2) ---------- */
NM.mq={paused:false,hover:false};const mqp=$('#mqp');
if(mqp){mqp.addEventListener('click',()=>{NM.mq.paused=!NM.mq.paused;mqp.setAttribute('aria-pressed',NM.mq.paused);mqp.setAttribute('aria-label',NM.mq.paused?NM.strings.resumeMq:NM.strings.pauseMq)});
const sec=$('.bmq');['mouseenter','focusin'].forEach(ev=>sec.addEventListener(ev,()=>NM.mq.hover=true));['mouseleave','focusout'].forEach(ev=>sec.addEventListener(ev,()=>NM.mq.hover=false))}
/* ---------- pestañas del ritual (sin animación: desplaza al momento) ---------- */
NM.tabGo=i=>{const el=$('#mo'+i);if(el)el.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'})};
$$('.tabs button').forEach(b=>b.addEventListener('click',()=>NM.tabGo(+b.dataset.i)));
/* P14 · entradas de Tres frascos y DynaMind en móvil. No toca Lenis ni ScrollTrigger.
   Sin esta clase el CSS no oculta nada. Si el observer no dispara, un temporizador abre igual. */
if(!reduce && matchMedia('(max-width:820px)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches){
  root.classList.add('js-anim-ready');
  const arm=el=>{
    if(!el)return;
    const go=()=>{
      if(el.classList.contains('is-in'))return;
      el.classList.add('is-in');
      if(el.id!=='spot')return;
      el.querySelectorAll('.gd b').forEach(b=>{
        const raw=b.textContent.trim(),m=raw.match(/^(\d+)/);
        if(!m)return;
        const end=+m[1],suf=raw.slice(m[1].length),t0=performance.now();
        b.textContent='0'+suf;
        (function step(now){const p=Math.min(1,(now-t0)/880),e=1-Math.pow(1-p,3);b.textContent=Math.round(end*e)+suf;if(p<1)requestAnimationFrame(step)})(t0);
      });
    };
    if('IntersectionObserver' in window){
      const io=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){go();io.disconnect()}})},{threshold:.22});
      io.observe(el);
    }
    setTimeout(go,1800);
  };
  arm($('#stack'));arm($('#spot'));
}
});
